import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import Payment from "./Payment";

const PaymentLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Payments" />
      <Payment />
    </MasterLayout>
  );
};

export default PaymentLayout;
